import { useState, useEffect } from "react";
import { ProductItem } from "../../api/QuickOrder";
import { useWishlist } from "hooks/useWishlist";
import RightBorderQualityControl from "providers/QualityControlComponent/RightBorderQualityControl";

interface ProductListProps {
    cartItems: ProductItem[];
    onUpdateQuantity: (id: number, qty: number) => void;
}

interface QuantityState {
    [key: number]: number;
}

export default function ProductList({ cartItems, onUpdateQuantity }: ProductListProps) {
    const { handleToggleWishlist, isInWishlist } = useWishlist();
    const DEFAULT_MAX_ORDER = 999;

    const formatCurrency = (amount: number) => {
        return new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(amount);
    }

    const increase = (id: number, currentQty: number, max: number = DEFAULT_MAX_ORDER): void => {
        const newQty = Math.min(currentQty + 1, max);
        onUpdateQuantity(id, newQty);
    };

    const decrease = (id: number, currentQty: number): void => {
        const newQty = Math.max(currentQty - 1, 0);
        onUpdateQuantity(id, newQty);
    };

    const changeInput = (id: number, max: number = DEFAULT_MAX_ORDER, value: string): void => {
        const v = Number(value);
        if (isNaN(v)) return;
        const newQty = Math.max(0, Math.min(v, max));
        onUpdateQuantity(id, newQty);
    };



    if (!cartItems || cartItems.length === 0) return null;

    return (
        <div className="styles_listProducts__nQnSb">
            {cartItems.map((item) => {
                const product = item;
                const productId = product.id;
                const currentQty = item.quantity || 0;
                const displayQty = currentQty > 0 ? currentQty : 1;
                const totalPrice = product.price * displayQty;

                return (
                    <div className="styles_cardWrapper__DC_WP" key={productId}>
                        <div className="MuiPaper-root MuiCard-root styles_card__wBpbF MuiPaper-elevation1 MuiPaper-rounded">

                            <div
                                className="styles_cardWishList__xjQ_X"
                                onClick={() => handleToggleWishlist(productId)}
                                role="button"
                                style={{ cursor: "pointer" }}
                            >
                                <img
                                    src={
                                        isInWishlist(productId)
                                            ? "https://cdn-web-next.thuocsi.vn/icons/wish_list_active.svg"
                                            : "https://cdn-web-next.thuocsi.vn/icons/wish_list_inactive.svg"
                                    }
                                    alt="wishlist"
                                />
                            </div>

                            <div className="styles_cardImage__NDRZc">
                                <img
                                    className="styles_image__j5quc"
                                    src={product.avatar}
                                    alt={product.name}
                                />
                            </div>

                            <div className="MuiCardContent-root styles_cardDesc__EzCGV">
                                <a className="styles_cardTitle__cU0KJ" href={`/product/${product.slug}`}>
                                    <span>{product.name}</span>
                                </a>
                                {/* Badge areas */}
                                <div className="styles_cardStore__F6qYF MuiBox-root css-0">
                                    <span style={{ boxSizing: "border-box", display: "inline-block", overflow: "hidden", width: "initial", height: "initial", background: "none", opacity: 1, border: "0px", margin: "0px", padding: "0px", position: "relative", maxWidth: "100%" }}>
                                        <span style={{ boxSizing: "border-box", display: "block", width: "initial", height: "initial", background: "none", opacity: 1, border: "0px", margin: "0px", padding: "0px", maxWidth: "100%" }}>
                                            <img alt="" aria-hidden="true" src="data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%2713%27%20height=%2713%27/%3e" style={{ display: "block", maxWidth: "100%", width: "initial", height: "initial", background: "none", opacity: 1, border: "0px", margin: "0px", padding: "0px" }} />
                                        </span>
                                        <img src="https://cdn-web-next.thuocsi.vn/icons/seller_store.svg" decoding="async" data-nimg="intrinsic" style={{ position: "absolute", inset: "0px", boxSizing: "border-box", padding: "0px", border: "none", margin: "auto", display: "block", width: "0px", height: "0px", minWidth: "100%", maxWidth: "100%", minHeight: "100%", maxHeight: "100%" }} />
                                    </span>
                                    <a className="styles_cardNameStore__a_Oks" target="_blank" href="#">MEDX</a>
                                </div>
                                {/* <div className="styles_cardBadges__JMC4V MuiBox-root css-0">
                                    <a className="styles_mobile_rootBase__8z7PQ" target="_blank" href="/tag/tamhanhpharma-tro-gia">
                                        <img alt="tag-/tag/tamhanhpharma-tro-gia" src="/theme/Group_1000004196.svg" />
                                    </a>
                                    <a className="styles_mobile_rootBase__8z7PQ" target="_blank" href="/tag/hang-benh-vien">
                                        <img alt="tag-/tag/hang-benh-vien" src="/theme/Group_1000004190_2.svg" />
                                    </a>
                                </div> */}
                            </div>

                            <div className="MuiCardContent-root styles_cardPrice__Phq1m">
                                <div className="styles_cardPriceItem__0Z9Ac MuiBox-root css-0">
                                    <a className="styles_cardCurrentPrice__FRdV0" href={`/product/${product.slug}`}>
                                        <div className="styles_flex_no_wrap__1vvft MuiBox-root css-0">
                                            <div className="styles_canvasPrice__vw932" style={{ height: "30px" }}>
                                                {formatCurrency(totalPrice)}
                                            </div>
                                        </div>
                                    </a>
                                </div>
                            </div>

                            <div className="styles_cardActions__4sm0A MuiCardActions-root MuiCardActions-spacing">
                                <div className="styles_cardActionsItem__PKAZb">
                                    <span className="styles_cardNoted__s14eQ">
                                        Đặt tối đa {DEFAULT_MAX_ORDER} sản phẩm
                                    </span>
                                </div>

                                <RightBorderQualityControl productId={productId} productName={product.name} />
                            </div>

                        </div>
                    </div>
                );
            })}
        </div>
    );
}